import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableBody from 'modules/_shared/Table/components/TableBody';
import { Eligible } from 'modules/transactions/pages/TenderOfferDetails/types/Eligible';

import IncentiveOfferEligiblesTableRow from './IncentiveOfferEligiblesTableRow';

type IncentiveOfferEligiblesTableBodyProps = {
  eligibles: Eligible[];
  page: number;
  rowsPerPage: number;
};

const IncentiveOfferEligiblesTableBody: FC<IncentiveOfferEligiblesTableBodyProps> = ({
  eligibles = [],
  page,
  rowsPerPage,
}) => {
  const { t } = useTranslate();

  const hasData = eligibles.length > 0;
  const startIndex = (page - 1) * rowsPerPage;

  const rows = eligibles.map((eligible, index) => (
    <IncentiveOfferEligiblesTableRow
      key={`${eligible.name}-${startIndex + index}`}
      rowNumber={startIndex + index + 1}
      eligible={eligible}
    />
  ));

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataColspan={14}
      noDataMessage={t('NoAvailableData')}
    />
  );
};

export default IncentiveOfferEligiblesTableBody;
